<template>
    <div
        class="inline-flex items-center gap-0.5 rounded-md border border-theme-border p-0.5"
    >
        <button
            v-for="option in options"
            :key="option.value"
            type="button"
            :title="option.label"
            :aria-label="option.label"
            class="flex items-center justify-center rounded p-1 transition-colors"
            :class="
                value === option.value
                    ? 'bg-theme-selected text-theme-primary'
                    : 'text-theme-muted hover:bg-theme-hover'
            "
            @click="$emit('input', option.value)"
        >
            <component :is="option.icon" class="w-3.5 h-3.5" />
        </button>
    </div>
</template>

<script>
import AlignCenterIcon from "@/components/icons/AlignCenterIcon.vue";
import AlignLeftIcon from "@/components/icons/AlignLeftIcon.vue";
import AlignRightIcon from "@/components/icons/AlignRightIcon.vue";

const OPTIONS = [
    { icon: "AlignLeftIcon", label: "Izquierda", value: "left" },
    { icon: "AlignCenterIcon", label: "Centro", value: "center" },
    { icon: "AlignRightIcon", label: "Derecha", value: "right" }
];

export default {
    name: "AlignmentPicker",
    components: { AlignCenterIcon, AlignLeftIcon, AlignRightIcon },
    model: {
        prop: "value",
        event: "input"
    },
    props: {
        value: {
            default: () => "left",
            type: String,
            required: false
        }
    },
    emits: ["input"],
    computed: {
        options() {
            return OPTIONS;
        }
    }
};
</script>
